define('controllers/admin/blog/blogController',[
	"application",
		"jquery",
		"angular",
		"config",
		"moment",
		"underscore",
		"toastr",
		"postaljs",
		"application",
		"directives/bootstrap/bsModal"
],
	function (app, $, angular, config, moment, _, toastr, postal) {
		"use strict";

		return app.controllers.controller("Blog", ["$scope", "$window", function ($scope, $window) {

				$scope.isBusy = false;

				$scope.dates = [];

				$scope.tags = [];

				$scope.posts = [];

				$scope.postToDelete = null;
				$scope.deletePost = function (post) {
					$scope.postToDelete = post;
				};
				$scope.deletePostConfirmed = function () {
					$scope.isBusy = true;

					$.post(config.admin.blog.deletePost, "=" + $scope.postToDelete.Id)
					.always(function () {
						$scope.$apply(function () {
							$scope.isBusy = false;
							$scope.postToDelete = null;
						});
					})
					.fail(function (reason) {
						toastr.error("Unable to delete post.");
					})
					.success(function (result) {
						reloadPosts();
					});
				};

				$scope.paging = {
					current: 1,
					total: 1,
					update: function (item) {
						$scope.paging.current = item;
						reloadPosts();
					}
				};

				$scope.filter = {
					tag: null,
					date: null,
					updateTag: function (item) {
						if (typeof item != "object")
							$scope.filter.tag = item;
						else
							$scope.filter.tag = null;

						reloadPosts();
					},
					updateDate: function (item) {
						if (item && item.Value && item.Date)
							$scope.filter.date = item.Value;
						else
							$scope.filter.date = null;

						reloadPosts();
					}
				};

				$scope.$watch("paging.total", function () {
					var current = $scope.paging.current;
					var result = [];

					for (var i = 1; i <= $scope.paging.total ; i++) {
						result.push(i);
					}

					$scope.paging.pages = result;
				});

				reloadPosts();

				function reloadPosts() {
					$scope.isBusy = true;

					$.post(config.admin.blog.getPosts, {
						page: $scope.paging.current,
						tag: $scope.filter.tag,
						date: $scope.filter.date
					})
						.always(function () {
							$scope.$apply(function () {
								$scope.isBusy = false;
							});
						})
						.fail(function () {
							toastr.error("Unable to load data.");
						})
						.success(function (result) {
							$scope.paging.current = result.CurrentPage;
							$scope.paging.total = result.PagesCount;

							$scope.posts = [];
							for (var i = 0; i < result.Items.length; i++) {
								$scope.posts.push($.extend(result.Items[i],
								{
									editUrl: config.admin.blog.editPostPage + "/" + result.Items[i].Id
								}));
							}

							$scope.tags = [];
							for (var i = 0; i < result.Tags.length; i++) {
								$scope.tags.push(result.Tags[i]);
							}

							$scope.dates = [];
							for (var i = 0; i < result.Arichve.length; i++) {
								$scope.dates.push(result.Arichve[i]);
							}

							$scope.$apply();
						});
				}

			}
		]);

	});
